/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import"../../../../intl.js";import{formatNumber as t}from"../../../../intl/number.js";function n(n){const{percentAlong:r}=n;return null==r?"":t(r,{style:"percent",maximumFractionDigits:2})}export{n as formatPercentAlong};
